<style lang="scss">
.pagination {
    justify-content: flex-end !important;
    .page-stats {
        align-items: center;
        margin-right: 5px;
    }
    a {
        background-color: #acacac !important;
        color: #fff;
        padding: 5px 5px 5px 5px;
        // margin:0px 5px 0px 5px;
        margin-top: -5px;
        margin-right: 5px;
        border-radius: 5px;
    }
}
</style>

<template>
    <nav class="pagination" v-if="!service">
        <span class="page-stats">{{pagination.from}} - {{pagination.to}} of {{pagination.total}}</span>
        <a v-if="pagination.prevPageUrl" class="btn btn-basic btn-sm" @click="$emit('prev');"><i class="fa fa-chevron-left"></i></a>
        <a class="btn btn-basic btn-sm" v-else :disabled="true"><i class="fa fa-chevron-left"></i></a>
        <a v-if="pagination.nextPageUrl" class="btn btn-default btn-sm" @click="$emit('next');"><i class="fa fa-chevron-right"></i></a>
        <a class="btn btn-default btn-sm" v-else :disabled="true"><i class="fa fa-chevron-right"></i></a>
    </nav>

    <nav class="pagination" v-else>
        <span class="page-stats">
            {{pagination.from}} - {{pagination.to}} of {{filtered.length}}
            <span v-if="filtered.length <= pagination.total">(filtered from {{pagination.total}} total entries)</span>
        </span>
        <a v-if="pagination.prevPage" class="btn btn-basic btn-sm" @click="$emit('prev');">
            <i class="fa fa-chevron-left"></i>
        </a>
        <a class="btn btn-basic btn-sm" v-else :disabled="true">
           <i class="fa fa-chevron-left"></i>
        </a>

        <a v-if="pagination.nextPage" class="btn btn-default btn-sm" @click="$emit('next');">
            <i class="fa fa-chevron-right"></i>
        </a>
        <a class="btn btn-default btn-sm" v-else :disabled="true">
            <i class="fa fa-chevron-right"></i>
        </a>
    </nav>

</template>

<script>
export default {
    props: ['pagination', 'service', 'filtered']
}
</script>



// WEBPACK FOOTER //
// resources/js/datatable/Pagination.vue